import { render, staticRenderFns } from "./AWContents.vue?vue&type=template&id=25ed7ee6&"
import script from "./AWContents.vue?vue&type=script&lang=js&"
export * from "./AWContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports